module.exports = __webpack_public_path__ + "img/browser-404.1c576a5a.png";